import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { PAGE, LIMIT } from "src/constants/searchParams";
import { toNumber } from "src/utils/toNumber";

export function useFromAndTo() {
  const [params] = useSearchParams();
  const page = useMemo(() => toNumber(params.get(PAGE)), [params]);
  const limit = useMemo(() => toNumber(params.get(LIMIT)), [params]);

  const from = useMemo(() => {
    const pageA = Number(page);
    const limitA = Number(limit);
    return pageA * limitA;
  }, [limit, page]);

  const to = useMemo(() => {
    const limitA = Number(limit);
    return from + limitA - 1;
  }, [from, limit]);

  return { from, to };
}
